import { ErrorHandler, Injectable } from '@angular/core';
import { AppConfig, ProductionTypes } from '@shared/utils/app-config';
import { ApplicationInsightsService } from './application-insights.service';

@Injectable()
export class ErrorHandlerService extends ErrorHandler {
  constructor(private appInsights: ApplicationInsightsService, private appConfig: AppConfig) {
    super();
  }

  public override handleError(error: Error): void {
    if (!this.appConfig.production) {
      console.error(error);

      return;
    }

    // Add additional context to the error report
    const additionalContext = {
      environment: ProductionTypes[this.appConfig.productionType],
    };

    // Log the error to Application Insights along with additional context
    this.appInsights.trackException(error, additionalContext);
  }
}
